
import "devextreme/data/odata/store"
import notify from 'devextreme/ui/notify'

import { DxButton } from 'devextreme-vue'
import { DxDateBox } from 'devextreme-vue/date-box'
import { DxTextBox } from 'devextreme-vue/text-box'
import { DxSelectBox } from 'devextreme-vue/select-box'
import { DxRadioGroup } from 'devextreme-vue/radio-group'
import { DxBox, DxItem } from 'devextreme-vue/box'

import { shiftPlanService } from '../../../services/shift-plan.service'

import moment from 'moment'

export default {
  components: {
    DxButton,
    DxDateBox,
    DxTextBox,
    DxRadioGroup,
    DxSelectBox,
    DxBox, DxItem,
  },
  data() {
    return {
      formType: "",
      workDate: moment(),
      currentShiftText: "",
      changeShifts: [],
      changeShiftId: "",
      workerMessage: "",
      changeRequestDisabled: false,
      officeResponseToWorkerVisible: false,
      officeMessage: "",
      beforeShiftText: "",
      afterShiftText: "",
      btnOKDisabled: false,
      btnCancelDisabled: false,
      btnOKVisible: false,
      btnCancelVisible: false,

      currentWorkerShift: {},
      currentWorkerShiftChange: {},
    }
  },
  methods: {
    fetchWorkerShiftChangeData() {

      let self = this

      let promiseGetAfterConfirmShifts = shiftPlanService.getAfterConfirmShifts(this.$route.params.workingDay)
      let promiseGetWorkerShiftChange = shiftPlanService.getWorkerShiftChange(this.$route.params.workingDay)

      Promise.all(
        [promiseGetAfterConfirmShifts
          , promiseGetWorkerShiftChange])
        .then((results) => {
          console.log(this.$route.params.workingDay)

          if (results[0].messageType == 1) {
            self.changeShifts = results[0].content
            self.changeShifts.forEach(function (shift) { shift.shiftCodeName = shift.shiftCode + (shift.shiftCode == "" ? "" : " : ") + shift.shiftName })
          } else {
            self.showMessage(results[0].message, 'error');
            self.onClickToBackShiftAdjust(null, self)
          }

          if (results[0].messageType == 1
            && results[1].messageType == 1) {

            self.currentWorkerShiftChange = results[1].content
            self.currentWorkerShift = self.currentWorkerShiftChange.workerShift

            if (self.isOutTimeOfficeShiftChangeJob(self.currentWorkerShift)) {

              self.showMessage(process.env.VUE_APP_BASE_MESSAGE_ROWVISION_WRONG, 'error');

              this.$store.commit(
                {
                  type: 'setShiftAdjustAllWorkerShiftsByWorkerShift',
                  workerShift: self.currentWorkerShift
                })
              self.onClickToBackShiftAdjust(null, self)

            } else {
              self.initFormInfo(self)
              if (self.formType == "confirm") {
                self.confirmWorkerShiftChange(self)
              }
            }
          } else {
            if(results[1].messageCode == "W00004"){
              self.showMessage(process.env.VUE_APP_BASE_MESSAGE_ROWVISION_WRONG, 'error');
            }else{
              self.showMessage(results[1].message, 'error');
            }
            
            self.onClickToBackShiftAdjust(null, self)
          }

          self.loadPanelVisible = false

        }).catch((errors) => {

          self.loadPanelVisible = false

          console.log(errors)
        })
    },
    confirmWorkerShiftChange(self) {

      self.currentWorkerShiftChange.treatStatusId = 3
      self.currentWorkerShiftChange._State_ = 4

      self.currentWorkerShift.changeStatusId = 0
      self.currentWorkerShift._State_ = 4

      shiftPlanService.confirmWorkerShiftChange(self.currentWorkerShift, self.currentWorkerShiftChange)
        .then(
          success => {
            if (success.messageType == 0) this.showMessage(success.message, 'error');
          },
          error => {
            console.log(error)
          }
        )
    },
    initFormInfo(self) {

      //formType btnOKDisabled btnCancelDisabled  btnOKVisible btnCancelVisible
      if (self.currentWorkerShiftChange.treatStatusId == -1) {
        self.formType = "create"
        self.btnOKVisible = true
        self.btnCancelVisible = false
        self.btnOKDisabled = false
        self.btnCancelDisabled = true
      }
      if (self.currentWorkerShiftChange.treatStatusId == 1) {
        self.formType = "cancel"
        self.btnOKVisible = false
        self.btnCancelVisible = true
        self.btnOKDisabled = true
        self.btnCancelDisabled = false
      }
      if (self.currentWorkerShiftChange.treatStatusId == 2) {
        self.formType = "confirm"
        self.btnOKVisible = false
        self.btnCancelVisible = false
        self.btnOKDisabled = true
        self.btnCancelDisabled = true
      }

      //workDate
      self.workDate = moment(self.currentWorkerShiftChange.workDate)

      //currentShiftText
      if (self.currentWorkerShift.shiftId != null) {
        self.currentShiftText =
          self.currentWorkerShift.shiftCode + ":" + self.currentWorkerShift.displayShiftTimeText
      } else {
        self.currentShiftText = "休"
      }

      //changeRequestDisabled
      self.changeRequestDisabled = self.currentWorkerShiftChange.treatStatusId == -1 ? false : true

      //workerMessage
      self.workerMessage = self.currentWorkerShiftChange.workerMessage

      //changeShiftId
      if (self.currentWorkerShiftChange.treatStatusId == -1) {
        self.changeShiftId = null
      } else {
        if (self.currentWorkerShiftChange.afterShiftId == null) {
          self.changeShiftId = -1
        } else {
          self.changeShiftId = self.currentWorkerShiftChange.afterShiftId
        }
      }

      //officeResponseToWorkerVisible
      self.officeResponseToWorkerVisible = self.currentWorkerShiftChange.treatStatusId == 2 ? true : false

      if (self.officeResponseToWorkerVisible) {
        //officeMessage
        self.officeMessage =
          (self.currentWorkerShiftChange.officeResultId == 1 ? "OK" : "NG")
          + (self.currentWorkerShiftChange.officeMessage == null ? "" : (":" + self.currentWorkerShiftChange.officeMessage))

        //beforeShiftText
        if (self.currentWorkerShiftChange.beforeShiftId != null) {
          self.beforeShiftText = self.currentWorkerShiftChange.beforeShiftText
        } else {
          self.beforeShiftText = "休"
        }

        //afterShiftText
        //事務所回答OKの場合、変更後のシフトを表示する
        if(self.currentWorkerShiftChange.officeResultId == 1){
          if (self.currentWorkerShiftChange.afterShiftId != null) {
            self.afterShiftText = self.currentWorkerShiftChange.afterShiftText
          } else {
            self.afterShiftText = "休"
          }
        }else{ //事務所回答NGの場合、変更前のシフトを表示する
          self.afterShiftText = self.beforeShiftText;
        }

      }
    },
    onClickToCreateChange() {
      if (this.changeShiftId == null) {
        this.showMessage(process.env.VUE_APP_BASE_MESSAGE_SELECT_CHANGE_SHIFT, 'error')
        return
      }
      if (this.changeShiftId == this.currentWorkerShift.shiftId || (this.changeShiftId == -1 && this.currentWorkerShift.shiftId == null)) {
        this.showMessage(process.env.VUE_APP_BASE_MESSAGE_SAME_SHIFT, 'error')
        return
      }
      if (this.workerMessage == null || this.workerMessage == "") {
        this.showMessage(process.env.VUE_APP_BASE_MESSAGE_CHANGE_REASON, 'error')
        return
      }

      if (this.changeShiftId != -1) {
        this.currentWorkerShiftChange.afterShiftId = this.changeShiftId
        for (let shift of this.changeShifts) {
          if (shift.shiftId == this.changeShiftId) {
            this.currentWorkerShiftChange.afterLaborHour = shift.laborHour
          }
        }
      }
      this.currentWorkerShiftChange.workerMessage = this.workerMessage
      this.currentWorkerShiftChange.treatStatusId = 1
      this.currentWorkerShiftChange.locationId = this.$store.state.worker.locationId

      this.currentWorkerShift.changeStatusId = 3
      this.currentWorkerShift._State_ = 4

      let self = this
      shiftPlanService.createWorkerShiftChange(this.currentWorkerShift, this.currentWorkerShiftChange)
        .then(
          success => {

            if (success.messageType == 1) {

              self.showMessage(success.message, 'success');

              setTimeout(self.onClickToBackShiftAdjust(null, self), 1000, self)

              self.changeRequestDisabled = true
              self.btnOKDisabled = true
            } else {
              self.showMessage(success.message, 'error');
            }
          },
          error => {
            console.log(error)
          }
        )
    },
    onClickToCancelChange() {
      this.currentWorkerShiftChange.treatStatusId = 4
      this.currentWorkerShiftChange._State_ = 4

      this.currentWorkerShift.changeStatusId = 0
      this.currentWorkerShift._State_ = 4

      let self = this
      shiftPlanService.cancelWorkerShiftChange(this.currentWorkerShift, this.currentWorkerShiftChange)
        .then(
          success => {
            if (success.messageType == 1) {

              self.showMessage(success.message, 'success');

              setTimeout(self.onClickToBackShiftAdjust(null, self), 1000, self)

              self.btnCancelDisabled = true
            } else {
              self.showMessage(success.message, 'error');
            }
          },
          error => {
            console.log(error)
          }
        )
    },
    isOutTimeOfficeShiftChangeJob(workerShift) {
      let year = moment(new Date(workerShift.workingDay)).year()
      let month = moment(workerShift.workingDay).month()

      for (let _monthlyWorkerShifts of this.$store.state.shiftAdjustAllWorkerShifts) {
        let _yearMonth = moment(new Date(_monthlyWorkerShifts.yearMonth))
        let _year = _yearMonth.year()
        let _month = _yearMonth.month()
        if (year == _year && month == _month) {
          for (let _workerShift of _monthlyWorkerShifts.workerShifts) {
            if (moment(new Date(workerShift.workingDay)).diff(moment(new Date(_workerShift.workingDay)), 'days') == 0) {
              if (workerShift.rowVersion != _workerShift.rowVersion || 
                workerShift.workerShiftChangeId != _workerShift.workerShiftChangeId ||
                workerShift.workerShiftChangeTreatStatusId != _workerShift.workerShiftChangeTreatStatusId) {
                return true
              } else {
                return false
              }
            }
          }
        }
      }
      return false
    },
    onClickToBackShiftAdjust(e, self) {
      if (e != null) self = this

      shiftPlanService.getWorkerShifts(
        moment(this.$route.params.workingDay).format("YYYY-MM-DD")
        , moment(this.$route.params.workingDay).format("YYYY-MM-DD"))
        .then(success => {
          if (success.messageType == 1) {
            self.$store.commit(
              {
                type: 'setShiftAdjustAllWorkerShiftsByWorkerShift',
                workerShift: success.content[0].workerShifts[0]
              })

            if (self.$store.state.fromUrlName != null && self.$store.state.fromUrlName != "") {
              self.$router.push({ name: self.$store.state.fromUrlName })
            } else {
              self.$router.push({ name: 'shift-adjustment' })
            }
          } else {
            self.showMessage(success.message, 'error');
          }
        }).catch((errors) => {
          console.log(errors)
        })
    },
    showMessage(text, type) {
      notify({ message: text, shading: true }, type, process.env.VUE_APP_BASE_MESSAGE_NOTIFY_SHOWTIME)
    },
  },
  mounted() {
    this.fetchWorkerShiftChangeData()
  },
  watch: {
    '$route': 'fetchWorkerShiftChangeData'
  },
}